import { IDDiagnosisNull } from 'models/DCK/basicInterface';
import moment from 'moment';
import { useState } from 'react';
import useToggle from './useToggle';

// sidebar 및 add-diagnosis 페이지에 cancel 버튼 hooks
export const useDialogueScheduleHooks = () => {
    const [selectedDate, setSelectedDate] = useState<string | null>(null);
    const [selectedTime, setSelectedTime] = useState<string | null>(null);
    const [selectedDialogueScheduleData, setSelectedDialogueScheduleData] = useState<IDDiagnosisNull | null>(null);

    const [onDialogueScheduleModal, setOnDialogueScheduleModal] = useToggle();

    const initDate = () => {
        moment.locale('ko');
        const now = moment();
        const roundedNow = now.minute() < 30 ? now.startOf('hour').add(30, 'minutes') : now.startOf('hour').add(1, 'hours');
        setSelectedDate(now.format('YYYY/MM/DD'));
        setSelectedTime(roundedNow.format('A h:mm'));
    };

    const onChangeDiagnosisDateModal = (data: IDDiagnosisNull) => {
        setSelectedDialogueScheduleData(data);
        setSelectedDate(moment(data.diagnosisDateTime, 'YYYYMMDDHHmm').format('YYYY/MM/DD'));
        setSelectedTime(moment(data.diagnosisDateTime, 'YYYYMMDDHHmm').format('A h:mm'));
        setOnDialogueScheduleModal();
    };

    // 취소 버튼
    const closeFillOutDialogueScheduleModal = () => {
        setSelectedDialogueScheduleData(null);
        setSelectedDate(null);
        setSelectedTime(null);
        setOnDialogueScheduleModal();
    };

    const getRqDataUpdateDiagnosisInfo = () => {
        const addNewCounselDateTime = selectedDialogueScheduleData?.noShowInfo?.map((item) => {
            if (!item.newCounselDateTime) {
                return {
                    ...item,
                    newCounselDateTime: moment(selectedDate).format('YYYYMMDD') + moment(selectedTime, 'A h:mm').format('HHmm'),
                };
            }
        });

        const rqData = {
            _id: selectedDialogueScheduleData!._id,
            diagnosisDateTime: moment(selectedDate).format('YYYYMMDD') + moment(selectedTime, 'A h:mm').format('HHmm'),
            diagnosisTimestamp: moment(selectedDate + ' ' + moment(selectedTime, 'A h:mm').format('HHmm'), 'YYYYMMDD HHmm').valueOf(),
            noShowInfo: addNewCounselDateTime,
        };

        return rqData;
    };

    return {
        selectedDate,
        setSelectedDate,
        selectedTime,
        setSelectedTime,
        selectedDialogueScheduleData,
        onDialogueScheduleModal,
        initDate,
        onChangeDiagnosisDateModal,
        closeFillOutDialogueScheduleModal,
        getRqDataUpdateDiagnosisInfo,
    };
};
